import { AuthService } from '../services/AuthService';
import { CustomError, type IGenericResponseRoot } from '../utils/getErrorData';
import { api } from '../utils/api';
import { type IUser } from '@/types/IUser';

export const uploadAvatar = async (
  userUuid: string,
  file: File
): Promise<IGenericResponseRoot<IUser>> => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const headers: Record<string, string> = {};
    if (AuthService.authToken !== null) {
      headers.Authorization = `Bearer ${AuthService.authToken}`;
    } else {
      throw new Error('Пользователь не авторизирован');
    }

    const response = await api.post<IGenericResponseRoot<IUser>>(
      `/admin/account/${userUuid}/avatar`,
      formData,
      { headers }
    );

    if (response.status === 500) {
      throw new CustomError(
        'Произошла необработанная ошибка при загрузке аватара'
      );
    }

    if (response.data.response === null) {
      throw new CustomError('При загрузке аватара произошла ошибка');
    }

    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    throw error;
  }
};

export const deleteAvatar = async (
  userUuid: string
): Promise<IGenericResponseRoot<IUser>> => {
  try {
    const headers: Record<string, string> = {};
    if (AuthService.authToken !== null) {
      headers.Authorization = `Bearer ${AuthService.authToken}`;
    } else {
      throw new Error('Пользователь не авторизирован');
    }

    const response = await api.delete<IGenericResponseRoot<IUser>>(
      `/admin/account/${userUuid}/avatar`,
      { headers }
    );

    if (response.status === 500) {
      throw new CustomError(
        'Произошла необработанная ошибка при удалении аватара'
      );
    }

    if (response.data.response === null) {
      throw new CustomError('При удалении аватара произошла ошибка');
    }

    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    throw error;
  }
};
